import React, { Component } from "react";
import { OperatorDataModel, UserTypeRelation } from "../../models/User";
import Loader from "../../components/Loader";
import { toastService } from "../../services/toastService";
import _ from "lodash";
import { operatorsApiService } from "../../services/api/users/OperatorApiService";
import EventEmitter, { Events } from "../../services/eventemitter";
import ProfileShared from "./ProfileShared";
import { RoleModel } from "../../models/Role";

interface ProfileState {
    user: OperatorDataModel | null;
    isLoading: boolean;
    roles: RoleModel[];
}

export default class OwnProfileComponent extends Component<unknown, ProfileState> {
    constructor(props: unknown) {
        super(props);

        this.state = {
            user: null,
            isLoading: true,
            roles: [],
        };
    }

    async componentDidMount() {
        this.setState({ isLoading: true });

        const userProfile = await operatorsApiService.get();

        if (!userProfile.success) {
            this.setState({ isLoading: false });
            toastService.error(userProfile.message);
            return;
        }

        const roleOwnResult = await operatorsApiService.getRoles();
        if (!roleOwnResult.success) {
            this.setState({ isLoading: false });
            toastService.error(roleOwnResult.message ?? "Bad Request");
            return;
        }

        this.setState({ isLoading: false, user: userProfile.data, roles: roleOwnResult.data });
    }

    showToast = (message: string) => {
        toastService.success(message, "Action Completed");
    };

    onSubmitButtonClick = async () => {
        this.setState({ isLoading: true });

        const newData = _.cloneDeep(this.state.user);

        const result = await operatorsApiService.updateOwn(newData!);

        this.setState({ isLoading: false });

        if (result.success) {
            EventEmitter.emit(Events.OnUserDataUpdate);
        } else {
            toastService.error(result.message);
        }
    };

    render() {
        if (this.state.isLoading || this.state.user === null) {
            return (
                <>
                    <Loader />
                </>
            );
        }

        return (
            <>
                <ProfileShared
                    allowResetPhoneAndMobile={false}
                    isEditMode={false}
                    showMerchant={false}
                    showRoles={true}
                    showPassword={false}
                    merchants={[]}
                    roles={this.state.roles}
                    user={this.state.user}
                    onUpdate={(user) => this.setState({ user: user })}
                    onSubmit={this.onSubmitButtonClick}
                    userType = {UserTypeRelation.Operator}
                />
            </>
        );
    }
}
